// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   APP HEADER / TOPBAR COMPONENT
   Figma Design System Specification — Node 429:22151
   Untouchable, isolated, and standardized across all application views.
   ========================================================================== */

:root {
  --app-topbar-height: 64px;
}

/* Light Theme Variables */
.app-topbar,
[data-theme="light"] .app-topbar,
.app-topbar:not(.dark) {
  --tb-bg: #ffffff;
  --tb-border: #dce3e2;
  --tb-search-bg: #f4f7f7;
  --tb-search-border: #dce3e2;
  --tb-search-focus-border: #0f766e;
  --tb-text: #142624;
  --tb-text-muted: #506360;
  --tb-text-tertiary: #6b7b78;
  --tb-icon: var(--tb-text-muted);
  --tb-interactive: #0f766e;
  --tb-on-interactive: #ffffff;
  --tb-danger: #c23a2b;
  --tb-credits-border: #cdd6d4;
  --tb-hover-bg: #f4f7f7;
  --tb-avatar-border: #dce3e2;
  --tb-status-ring: #ffffff;
  --tb-status-dot: #15703d;
  --tb-menu-bg: #ffffff;
  --tb-menu-border: #dce3e2;
  --tb-menu-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1),
    0 8px 10px -6px rgba(0, 0, 0, 0.08);
  --tb-menu-item-hover: #f4f7f7;
}

/* Dark Theme Variables */
[data-theme="dark"] .app-topbar,
.dark .app-topbar,
.app-topbar.dark,
.business-dashboard.dark .app-topbar,
.quotation-page.dark .app-topbar,
.quotation-editor-shell.dark .app-topbar {
  --tb-bg: #191b1f;
  --tb-border: #2c3036;
  --tb-search-bg: #22252a;
  --tb-search-border: #2c3036;
  --tb-search-focus-border: #43a79c;
  --tb-text: #f2f3f5;
  --tb-text-muted: #b3b8c2;
  --tb-text-tertiary: #9299a5;
  --tb-icon: var(--tb-text-muted);
  --tb-interactive: #43a79c;
  --tb-on-interactive: #101113;
  --tb-danger: #f08078;
  --tb-credits-border: #3a3f47;
  --tb-hover-bg: #22252a;
  --tb-avatar-border: #2c3036;
  --tb-status-ring: #191b1f;
  --tb-status-dot: #61bc8c;
  --tb-menu-bg: #191b1f;
  --tb-menu-border: #2c3036;
  --tb-menu-shadow: 0 12px 28px -5px rgba(0, 0, 0, 0.5),
    0 8px 10px -6px rgba(0, 0, 0, 0.4);
  --tb-menu-item-hover: #22252a;
}

/* --------------------------------------------------------------------------
   Root Container — Strictly isolated from parent/sibling interference
   -------------------------------------------------------------------------- */
#root .app-topbar,
.app-topbar {
  position: sticky !important;
  top: 0 !important;
  z-index: 100 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  width: 100% !important;
  height: 64px !important;
  min-height: 64px !important;
  max-height: 64px !important;
  padding: 0 24px !important;
  margin: 0 !important;
  background-color: var(--tb-bg) !important;
  border-bottom: 1px solid var(--tb-border) !important;
  box-sizing: border-box !important;
  font-family: var(
    --font-family-primary,
    "Lexend",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Roboto,
    sans-serif
  ) !important;
  transition: background-color 200ms ease, border-color 200ms ease;
}

/* --------------------------------------------------------------------------
   Left Section (Desktop Burger + Mobile Controls + Search)
   -------------------------------------------------------------------------- */
.app-topbar__left {
  display: flex !important;
  align-items: center !important;
  gap: 12px !important;
  flex: 1 1 auto !important;
  min-width: 0 !important;
}

.app-topbar__desktop-burger {
  display: none !important;
}

@media (min-width: 1025px) {
  body.sidebar-collapsed .app-topbar__desktop-burger,
  .app-topbar__desktop-burger.is-visible {
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 40px !important;
    height: 40px !important;
    min-width: 40px !important;
    min-height: 40px !important;
    padding: 0 !important;
    margin: 0 !important;
    border-radius: 10px !important;
    border: 1px solid var(--tb-search-border) !important;
    background-color: var(--tb-search-bg) !important;
    color: var(--tb-text-muted) !important;
    cursor: pointer !important;
    outline: none !important;
    transition: background-color 150ms ease, border-color 150ms ease,
      color 150ms ease !important;
    flex-shrink: 0 !important;
  }

  body.sidebar-collapsed .app-topbar__desktop-burger:hover,
  .app-topbar__desktop-burger.is-visible:hover {
    background-color: var(--tb-hover-bg) !important;
    border-color: var(--tb-search-focus-border) !important;
    color: var(--tb-text) !important;
  }

  .app-topbar__desktop-burger svg {
    width: 20px !important;
    height: 20px !important;
    stroke: currentColor !important;
    stroke-width: 2 !important;
    display: block !important;
  }
}

/* --------------------------------------------------------------------------
   Mobile Controls (hamburger + mobile search button)
   Hidden on desktop and tablet, visible on mobile phones (< 768px)
   -------------------------------------------------------------------------- */
.app-topbar__mobile-controls {
  display: none !important;
  align-items: center !important;
  gap: 8px !important;
}

.app-topbar__mobile-btn {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 44px !important;
  height: 44px !important;
  padding: 0 !important;
  margin: 0 !important;
  border-radius: 10px !important;
  border: 1px solid var(--border-subtle, var(--tb-border)) !important;
  background-color: var(--surface-secondary, var(--tb-search-bg)) !important;
  color: var(--text-primary, var(--tb-text)) !important;
  cursor: pointer !important;
  outline: none !important;
  transition: background-color 150ms ease, border-color 150ms ease;
}

.app-topbar__mobile-btn:hover {
  background-color: var(--surface-tertiary, var(--tb-hover-bg)) !important;
  border-color: var(--border-default, var(--tb-credits-border)) !important;
}

.app-topbar__mobile-btn svg {
  width: 20px !important;
  height: 20px !important;
  stroke: currentColor !important;
}

/* --------------------------------------------------------------------------
   Search Bar (Figma Node I429:22166;534:24814)
   -------------------------------------------------------------------------- */
.app-topbar__search {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  width: 100% !important;
  max-width: 320px !important;
  min-width: 80px !important;
  height: 40px !important;
  padding: 0 12px !important;
  margin: 0 !important;
  border-radius: 10px !important;
  border: 1px solid var(--tb-search-border) !important;
  background-color: var(--tb-search-bg) !important;
  box-sizing: border-box !important;
  cursor: text !important;
  transition: border-color 150ms ease, box-shadow 150ms ease,
    background-color 150ms ease;
}

.app-topbar__search:focus-within {
  border-color: var(--tb-search-focus-border) !important;
  box-shadow: none !important;
}

.app-topbar__search-icon {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 16px !important;
  height: 16px !important;
  flex-shrink: 0 !important;
  color: var(--tb-text-tertiary) !important;
}

.app-topbar__search-icon svg {
  width: 16px !important;
  height: 16px !important;
  display: block !important;
  stroke: currentColor !important;
}

.app-topbar__search-input {
  flex: 1 1 !important;
  min-width: 0 !important;
  width: 100% !important;
  height: 100% !important;
  padding: 0 !important;
  margin: 0 !important;
  border: none !important;
  outline: none !important;
  background: transparent !important;
  color: var(--tb-text) !important;
  font-family: var(--font-family-primary, "Lexend", sans-serif) !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: normal !important;
  letter-spacing: 0 !important;
}

.app-topbar__search .app-topbar__search-clear {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  flex: 0 0 28px !important;
  width: 28px !important;
  height: 28px !important;
  padding: 4px !important;
  border: 0 !important;
  border-radius: var(--radius-sm, 4px) !important;
  background: transparent !important;
  color: var(--tb-text-tertiary) !important;
  cursor: pointer !important;
}

.app-topbar__search .app-topbar__search-clear:hover {
  background: var(--tb-hover-bg) !important;
}

.app-topbar__search .app-topbar__search-clear:focus-visible {
  outline: 2px solid var(--tb-search-focus-border) !important;
}

.app-topbar__search .app-topbar__search-clear svg {
  width: 16px !important;
  height: 16px !important;
  color: currentColor !important;
}

.app-topbar__search-input::placeholder {
  color: var(--tb-text-tertiary) !important;
  opacity: 1 !important;
  font-family: var(--font-family-primary, "Lexend", sans-serif) !important;
  font-size: 14px !important;
  font-weight: 400 !important;
}

/* --------------------------------------------------------------------------
   Top Actions (Figma Node I429:22166;534:21917)
   -------------------------------------------------------------------------- */
.app-topbar__actions {
  display: flex !important;
  align-items: center !important;
  gap: 16px !important;
  margin: 0 !important;
  padding: 0 !important;
  flex-shrink: 0 !important;
}

/* Shared action-name tooltip for the right-side header controls. */
.app-topbar__actions [data-tooltip]::after {
  content: attr(data-tooltip);
  position: absolute;
  z-index: 1100;
  top: calc(100% + 8px);
  left: 50%;
  padding: 6px 9px;
  border: 1px solid var(--tb-menu-border);
  border-radius: 6px;
  background: var(--tb-menu-bg);
  box-shadow: 0 4px 12px rgba(14, 26, 32, 0.14);
  color: var(--tb-text);
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  transform: translate(-50%, -4px);
  transition: opacity 120ms ease, transform 120ms ease;
}

.app-topbar__actions [data-tooltip]:hover::after,
.app-topbar__actions [data-tooltip]:focus-visible::after {
  opacity: 1;
  transform: translate(-50%, 0);
}

.app-topbar__profile-control.is-open::after {
  display: none;
}

/* Credits Badge (Figma Node I429:22166;158:5021) */
.app-topbar__credits {
  display: inline-flex !important;
  align-items: center !important;
  gap: 6px !important;
  height: 32px !important;
  padding: 0 12px 0 10px !important;
  margin: 0 !important;
  border-radius: 999px !important;
  border: 1px solid var(--tb-credits-border) !important;
  background-color: transparent !important;
  color: var(--tb-text) !important;
  font-family: var(--font-family-primary, "Lexend", sans-serif) !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  line-height: normal !important;
  white-space: nowrap !important;
  cursor: pointer !important;
  text-decoration: none !important;
  box-sizing: border-box !important;
  transition: background-color 150ms ease, border-color 150ms ease;
}

.app-topbar__credits:hover {
  background-color: var(--tb-hover-bg) !important;
}

.app-topbar__credits-icon {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 16px !important;
  height: 16px !important;
  flex-shrink: 0 !important;
  color: var(--tb-icon) !important;
}

.app-topbar__credits-icon svg {
  width: 16px !important;
  height: 16px !important;
  display: block !important;
  stroke: currentColor !important;
}

/* Circle Action Buttons: Help & Notifications (Figma Nodes 158:5025, 158:5028) */
.app-topbar__icon-btn {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 36px !important;
  height: 36px !important;
  padding: 0 !important;
  margin: 0 !important;
  border-radius: 18px !important;
  border: none !important;
  outline: none !important;
  background-color: transparent !important;
  color: var(--tb-icon) !important;
  cursor: pointer !important;
  position: relative !important;
  flex-shrink: 0 !important;
  transition: background-color 150ms ease, color 150ms ease;
}

.app-topbar__icon-btn:hover {
  background-color: var(--tb-hover-bg) !important;
}

.app-topbar__refresh-btn:focus-visible {
  outline: 2px solid var(--focus-ring) !important;
  outline-offset: 2px !important;
}

.app-topbar__icon-btn svg {
  width: 20px !important;
  height: 20px !important;
  display: block !important;
  stroke: currentColor !important;
}

/* Notification unread badge dot */
.app-topbar__notif-badge {
  position: absolute !important;
  top: 7px !important;
  right: 7px !important;
  width: 7px !important;
  height: 7px !important;
  border-radius: 50% !important;
  background-color: var(--tb-danger) !important;
  border: 1.5px solid var(--tb-bg) !important;
}

/* Profile Control (Figma Node I429:22166;422:17533) */
.app-topbar__profile-control {
  display: flex !important;
  align-items: center !important;
  gap: 4px !important;
  padding: 4px !important;
  margin: 0 !important;
  border-radius: 8px !important;
  border: none !important;
  outline: none !important;
  background-color: transparent !important;
  cursor: pointer !important;
  position: relative !important;
  flex-shrink: 0 !important;
  transition: background-color 150ms ease;
}

.app-topbar__profile-control:hover,
.app-topbar__profile-control.is-open {
  background-color: var(--tb-hover-bg) !important;
}

/* Avatar (Figma Node I429:22166;158:5031) */
.app-topbar__avatar {
  position: relative !important;
  width: 32px !important;
  height: 32px !important;
  border-radius: 16px !important;
  border: 1.5px solid var(--tb-avatar-border) !important;
  background-color: var(--tb-interactive) !important;
  color: var(--tb-on-interactive) !important;
  box-sizing: border-box !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-family: var(--font-family-primary, "Lexend", sans-serif) !important;
  font-size: 11px !important;
  font-weight: 500 !important;
  line-height: 1 !important;
  -webkit-user-select: none !important;
          user-select: none !important;
  flex-shrink: 0 !important;
}

.app-topbar__avatar img {
  width: 100% !important;
  height: 100% !important;
  border-radius: 16px !important;
  object-fit: cover !important;
  display: block !important;
  pointer-events: none !important;
}

/* Online status dot & ring */
.app-topbar__status-dot {
  position: absolute !important;
  right: -1px !important;
  bottom: -1px !important;
  width: 8px !important;
  height: 8px !important;
  border-radius: 50% !important;
  background-color: var(--tb-status-dot) !important;
  border: 1.5px solid var(--tb-status-ring) !important;
  box-sizing: content-box !important;
}

/* Chevron Down (Figma Node I429:22166;422:17763) */
.app-topbar__chevron {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 16px !important;
  height: 16px !important;
  color: var(--tb-icon) !important;
  transition: transform 160ms cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.app-topbar__chevron svg {
  width: 16px !important;
  height: 16px !important;
  display: block !important;
  stroke: currentColor !important;
}

.app-topbar__profile-control.is-open .app-topbar__chevron {
  transform: rotate(180deg) !important;
}

/* --------------------------------------------------------------------------
   Profile Menu Popover
   -------------------------------------------------------------------------- */
.app-topbar__menu {
  position: absolute !important;
  top: calc(100% - 4px) !important;
  right: 24px !important;
  z-index: 1000 !important;
  width: 240px !important;
  padding: 4px !important;
  border-radius: 10px !important;
  border: 1px solid var(--tb-menu-border) !important;
  background-color: var(--tb-menu-bg) !important;
  box-shadow: 0 6px 16px -4px rgba(14, 26, 32, 0.1),
    0 1px 2px rgba(14, 26, 32, 0.04) !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 2px !important;
  font-family: var(--font-family-primary, "Lexend", sans-serif) !important;
  animation: appTopbarMenuIn 150ms cubic-bezier(0.16, 1, 0.3, 1) !important;
}

@keyframes appTopbarMenuIn {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.app-topbar__menu-credits {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  padding: 10px 12px !important;
  border-radius: 8px !important;
  background-color: var(--tb-search-bg) !important;
  border: 1px solid var(--tb-border) !important;
  color: var(--tb-text) !important;
  font-size: 13px !important;
}

.app-topbar__menu-credits > div {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
}

.app-topbar__menu-credits strong {
  font-weight: 600 !important;
}

.app-topbar__menu-btn {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  width: 100% !important;
  height: 36px !important;
  padding: 0 12px !important;
  margin: 0 !important;
  border-radius: 4px !important;
  border: none !important;
  outline: none !important;
  background: transparent !important;
  color: var(--tb-text) !important;
  font-family: var(--font-family-primary, "Lexend", sans-serif) !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  text-align: left !important;
  cursor: pointer !important;
  transition: background-color 120ms ease;
}

.app-topbar__menu-btn:hover {
  background-color: var(--tb-menu-item-hover) !important;
}

.app-topbar__menu-btn svg {
  width: 20px !important;
  height: 20px !important;
  stroke: currentColor !important;
  color: var(--tb-text-muted) !important;
  flex-shrink: 0 !important;
}

.app-topbar__menu-theme {
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
  gap: 8px !important;
  padding: 8px 12px !important;
}

.app-topbar__menu-theme > span {
  font-size: 13px !important;
  color: var(--tb-text-muted) !important;
}

.app-topbar__theme-toggle {
  display: flex !important;
  width: 168px !important;
  height: 36px !important;
  padding: 4px !important;
  gap: 4px !important;
  border-radius: 10px !important;
  background-color: transparent !important;
  border: none !important;
}

.app-topbar__theme-toggle button {
  display: inline-flex !important;
  align-items: center !important;
  gap: 4px !important;
  height: 28px !important;
  width: 78px !important;
  padding: 0 8px !important;
  border-radius: 6px !important;
  border: none !important;
  background: transparent !important;
  color: var(--tb-text-muted) !important;
  font-family: var(--font-family-primary, "Lexend", sans-serif) !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  cursor: pointer !important;
  transition: background-color 120ms ease, color 120ms ease;
}

.app-topbar__theme-toggle button.active {
  background-color: var(--tb-bg) !important;
  color: var(--tb-text) !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;
}

.app-topbar__theme-toggle button svg {
  width: 14px !important;
  height: 14px !important;
  stroke: currentColor !important;
}

.app-topbar__theme-toggle button:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 3px;
}

.app-topbar__menu-divider {
  width: 100% !important;
  height: 1px !important;
  background-color: var(--tb-border) !important;
  margin: 4px 0 !important;
}

/* --------------------------------------------------------------------------
   RESPONSIVE BREAKPOINTS
   -------------------------------------------------------------------------- */

/* Tablet (768px to 1024px) — Matches Figma Node 539:64178:
   Full search and credits visible, mobile toggle hidden */
@media (min-width: 768px) and (max-width: 1024px) {
  #root .app-topbar,
  .app-topbar {
    padding: 0 24px !important;
  }
  body:has(.dashboard-product-identity) .app-topbar__mobile-controls,
  .business-dashboard:has(.dashboard-product-identity)
    .app-topbar__mobile-controls,
  .dashboard-main:has(.dashboard-product-identity)
    .app-topbar__mobile-controls {
    display: none !important;
  }
  .app-topbar__search {
    display: flex !important;
    max-width: 320px !important;
  }
  .app-topbar__credits {
    display: inline-flex !important;
  }
  .app-topbar__icon-btn {
    display: flex !important;
  }
}

/* Mobile Phones (max-width: 767px) — Matches Figma Node 551:41126:
   Mobile controls shown, search input & credits hidden, bell + profile visible */
@media (max-width: 767px) {
  #root .app-topbar,
  .app-topbar {
    padding: 0 16px !important;
  }
  .app-topbar__mobile-controls {
    display: flex !important;
  }
  .app-topbar__search {
    display: none !important;
  }
  .app-topbar__search.is-mobile-open {
    display: flex !important;
    position: absolute !important;
    left: 16px !important;
    right: 16px !important;
    top: 12px !important;
    width: calc(100% - 32px) !important;
    max-width: none !important;
    z-index: 10 !important;
    background-color: var(--tb-bg) !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
  }
  .app-topbar__credits {
    display: none !important;
  }
  .app-topbar__help-btn {
    display: none !important;
  }
  .app-topbar__actions {
    gap: 8px !important;
  }
  .app-topbar__menu {
    right: 16px !important;
    width: calc(100% - 32px) !important;
    max-width: 280px !important;
  }
}

.app-topbar__search {
  position: relative;
}

.app-topbar__search-results {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  width: min(420px, calc(100vw - 32px));
  max-height: 60vh;
  overflow-y: auto;
  padding: 8px;
  border: 1px solid var(--tb-border);
  border-radius: 10px;
  background: var(--tb-menu-bg);
  color: var(--tb-text);
  box-shadow: var(--tb-menu-shadow);
  z-index: 20;
}

.app-topbar__search-results p {
  padding: 8px;
  margin: 0;
  font-size: 13px;
}

.app-topbar__search-results [role="option"] {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  padding: 10px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: var(--tb-text);
  text-align: left;
  font: inherit;
  cursor: pointer;
}

.app-topbar__search-results [role="option"]:hover,
.app-topbar__search-results [role="option"][aria-selected="true"] {
  background: var(--tb-menu-item-hover);
}

.app-topbar__search-results button:focus-visible {
  outline: 2px solid var(--tb-search-focus-border);
}

.app-topbar__search-results span,
.app-topbar__search-results small {
  color: var(--tb-text-muted);
  font-size: 12px;
  overflow-wrap: anywhere;
}

.app-topbar__search-results strong {
  font-size: 14px;
  overflow-wrap: anywhere;
}
`, "",{"version":3,"sources":["webpack://./src/components/AppHeader/AppHeader.css"],"names":[],"mappings":"AAAA;;;;+EAI+E;;AAE/E;EACE,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;;;EAGE,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,kBAAkB;EAClB,wBAAwB;EACxB,2BAA2B;EAC3B,+BAA+B;EAC/B,yBAAyB;EACzB,4BAA4B;EAC5B,oBAAoB;EACpB,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;EAC3B,yBAAyB;EACzB,wBAAwB;EACxB,qBAAqB;EACrB,yBAAyB;EACzB;uCACqC;EACrC,6BAA6B;AAC/B;;AAEA,yBAAyB;AACzB;;;;;;EAME,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,kBAAkB;EAClB,wBAAwB;EACxB,2BAA2B;EAC3B,+BAA+B;EAC/B,yBAAyB;EACzB,4BAA4B;EAC5B,oBAAoB;EACpB,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;EAC3B,yBAAyB;EACzB,wBAAwB;EACxB,qBAAqB;EACrB,yBAAyB;EACzB;sCACoC;EACpC,6BAA6B;AAC/B;;AAEA;;+EAE+E;AAC/E;;EAEE,2BAA2B;EAC3B,iBAAiB;EACjB,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;EACzC,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,0BAA0B;EAC1B,oBAAoB;EACpB,yCAAyC;EACzC,oDAAoD;EACpD,iCAAiC;EACjC;;;;;;;;cAQY;EACZ,gEAAgE;AAClE;;AAEA;;+EAE+E;AAC/E;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,oBAAoB;EACpB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;;IAEE,+BAA+B;IAC/B,8BAA8B;IAC9B,kCAAkC;IAClC,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,2BAA2B;IAC3B,qBAAqB;IACrB,oBAAoB;IACpB,8BAA8B;IAC9B,oDAAoD;IACpD,gDAAgD;IAChD,sCAAsC;IACtC,0BAA0B;IAC1B,wBAAwB;IACxB;iCAC6B;IAC7B,yBAAyB;EAC3B;;EAEA;;IAEE,+CAA+C;IAC/C,sDAAsD;IACtD,gCAAgC;EAClC;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,+BAA+B;IAC/B,0BAA0B;IAC1B,yBAAyB;EAC3B;AACF;;AAEA;;;+EAG+E;AAC/E;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;EACpB,8BAA8B;EAC9B,mEAAmE;EACnE,0EAA0E;EAC1E,qDAAqD;EACrD,0BAA0B;EAC1B,wBAAwB;EACxB,gEAAgE;AAClE;;AAEA;EACE,wEAAwE;EACxE,wEAAwE;AAC1E;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;;+EAE+E;AAC/E;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,2BAA2B;EAC3B,0BAA0B;EAC1B,uBAAuB;EACvB,0BAA0B;EAC1B,oBAAoB;EACpB,8BAA8B;EAC9B,oDAAoD;EACpD,gDAAgD;EAChD,iCAAiC;EACjC,uBAAuB;EACvB;+BAC6B;AAC/B;;AAEA;EACE,sDAAsD;EACtD,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,oBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;EACvB,wBAAwB;EACxB,kCAAkC;EAClC,gCAAgC;EAChC,wEAAwE;EACxE,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;EACpB,+CAA+C;EAC/C,kCAAkC;EAClC,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;EACrB,wEAAwE;EACxE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;;+EAE+E;AAC/E;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,mEAAmE;AACnE;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,gBAAgB;EAChB,uCAAuC;EACvC,kBAAkB;EAClB,6BAA6B;EAC7B,6CAA6C;EAC7C,qBAAqB;EACrB,6DAA6D;EAC7D,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,gCAAgC;EAChC,oDAAoD;AACtD;;AAEA;;EAEE,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA,mDAAmD;AACnD;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,oBAAoB;EACpB,+BAA+B;EAC/B,qDAAqD;EACrD,wCAAwC;EACxC,gCAAgC;EAChC,wEAAwE;EACxE,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,8BAA8B;EAC9B,0BAA0B;EAC1B,gCAAgC;EAChC,iCAAiC;EACjC,gEAAgE;AAClE;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA,iFAAiF;AACjF;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;EACpB,8BAA8B;EAC9B,uBAAuB;EACvB,wBAAwB;EACxB,wCAAwC;EACxC,gCAAgC;EAChC,0BAA0B;EAC1B,6BAA6B;EAC7B,yBAAyB;EACzB,yDAAyD;AAC3D;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;EAC/C,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA,kCAAkC;AAClC;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,6BAA6B;EAC7B,6CAA6C;EAC7C,2CAA2C;AAC7C;;AAEA,sDAAsD;AACtD;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,6BAA6B;EAC7B,uBAAuB;EACvB,wBAAwB;EACxB,wCAAwC;EACxC,0BAA0B;EAC1B,6BAA6B;EAC7B,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;;EAEE,+CAA+C;AACjD;;AAEA,4CAA4C;AAC5C;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,sDAAsD;EACtD,kDAAkD;EAClD,0CAA0C;EAC1C,iCAAiC;EACjC,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,wEAAwE;EACxE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,oCAA4B;UAA5B,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,4BAA4B;EAC5B,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA,6BAA6B;AAC7B;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;EACtB,6BAA6B;EAC7B,iDAAiD;EACjD,oDAAoD;EACpD,kCAAkC;AACpC;;AAEA,mDAAmD;AACnD;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,sBAAsB;EACtB,uBAAuB;EACvB,gCAAgC;EAChC,mEAAmE;AACrE;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;+EAE+E;AAC/E;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,sBAAsB;EACtB,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;EACvB,8BAA8B;EAC9B,kDAAkD;EAClD,8CAA8C;EAC9C;+CAC6C;EAC7C,wBAAwB;EACxB,iCAAiC;EACjC,mBAAmB;EACnB,wEAAwE;EACxE,yEAAyE;AAC3E;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;EACzC,6BAA6B;EAC7B,6BAA6B;EAC7B,gDAAgD;EAChD,6CAA6C;EAC7C,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,oBAAoB;EACpB,6BAA6B;EAC7B,uBAAuB;EACvB,wBAAwB;EACxB,kCAAkC;EAClC,gCAAgC;EAChC,wEAAwE;EACxE,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,+BAA+B;EAC/B,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,kCAAkC;EAClC,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;EAC9B,wCAAwC;EACxC,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;EAC7B,uBAAuB;EACvB,kCAAkC;EAClC,sCAAsC;EACtC,wEAAwE;EACxE,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,yDAAyD;AAC3D;;AAEA;EACE,yCAAyC;EACzC,gCAAgC;EAChC,mDAAmD;AACrD;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,6CAA6C;EAC7C,wBAAwB;AAC1B;;AAEA;;+EAE+E;;AAE/E;0DAC0D;AAC1D;EACE;;IAEE,0BAA0B;EAC5B;EACA;;;;;IAKE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;IACxB,2BAA2B;EAC7B;EACA;IACE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;iFACiF;AACjF;EACE;;IAEE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;IACxB,6BAA6B;IAC7B,qBAAqB;IACrB,sBAAsB;IACtB,oBAAoB;IACpB,mCAAmC;IACnC,0BAA0B;IAC1B,sBAAsB;IACtB,yCAAyC;IACzC,oDAAoD;EACtD;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;IACtB,mCAAmC;IACnC,2BAA2B;EAC7B;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;EACrB,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,gDAAgD;AAClD;;AAEA;;EAEE,2BAA2B;EAC3B,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,uBAAuB;AACzB","sourcesContent":["/* ==========================================================================\n   APP HEADER / TOPBAR COMPONENT\n   Figma Design System Specification — Node 429:22151\n   Untouchable, isolated, and standardized across all application views.\n   ========================================================================== */\n\n:root {\n  --app-topbar-height: 64px;\n}\n\n/* Light Theme Variables */\n.app-topbar,\n[data-theme=\"light\"] .app-topbar,\n.app-topbar:not(.dark) {\n  --tb-bg: #ffffff;\n  --tb-border: #dce3e2;\n  --tb-search-bg: #f4f7f7;\n  --tb-search-border: #dce3e2;\n  --tb-search-focus-border: #0f766e;\n  --tb-text: #142624;\n  --tb-text-muted: #506360;\n  --tb-text-tertiary: #6b7b78;\n  --tb-icon: var(--tb-text-muted);\n  --tb-interactive: #0f766e;\n  --tb-on-interactive: #ffffff;\n  --tb-danger: #c23a2b;\n  --tb-credits-border: #cdd6d4;\n  --tb-hover-bg: #f4f7f7;\n  --tb-avatar-border: #dce3e2;\n  --tb-status-ring: #ffffff;\n  --tb-status-dot: #15703d;\n  --tb-menu-bg: #ffffff;\n  --tb-menu-border: #dce3e2;\n  --tb-menu-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1),\n    0 8px 10px -6px rgba(0, 0, 0, 0.08);\n  --tb-menu-item-hover: #f4f7f7;\n}\n\n/* Dark Theme Variables */\n[data-theme=\"dark\"] .app-topbar,\n.dark .app-topbar,\n.app-topbar.dark,\n.business-dashboard.dark .app-topbar,\n.quotation-page.dark .app-topbar,\n.quotation-editor-shell.dark .app-topbar {\n  --tb-bg: #191b1f;\n  --tb-border: #2c3036;\n  --tb-search-bg: #22252a;\n  --tb-search-border: #2c3036;\n  --tb-search-focus-border: #43a79c;\n  --tb-text: #f2f3f5;\n  --tb-text-muted: #b3b8c2;\n  --tb-text-tertiary: #9299a5;\n  --tb-icon: var(--tb-text-muted);\n  --tb-interactive: #43a79c;\n  --tb-on-interactive: #101113;\n  --tb-danger: #f08078;\n  --tb-credits-border: #3a3f47;\n  --tb-hover-bg: #22252a;\n  --tb-avatar-border: #2c3036;\n  --tb-status-ring: #191b1f;\n  --tb-status-dot: #61bc8c;\n  --tb-menu-bg: #191b1f;\n  --tb-menu-border: #2c3036;\n  --tb-menu-shadow: 0 12px 28px -5px rgba(0, 0, 0, 0.5),\n    0 8px 10px -6px rgba(0, 0, 0, 0.4);\n  --tb-menu-item-hover: #22252a;\n}\n\n/* --------------------------------------------------------------------------\n   Root Container — Strictly isolated from parent/sibling interference\n   -------------------------------------------------------------------------- */\n#root .app-topbar,\n.app-topbar {\n  position: sticky !important;\n  top: 0 !important;\n  z-index: 100 !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n  width: 100% !important;\n  height: 64px !important;\n  min-height: 64px !important;\n  max-height: 64px !important;\n  padding: 0 24px !important;\n  margin: 0 !important;\n  background-color: var(--tb-bg) !important;\n  border-bottom: 1px solid var(--tb-border) !important;\n  box-sizing: border-box !important;\n  font-family: var(\n    --font-family-primary,\n    \"Lexend\",\n    -apple-system,\n    BlinkMacSystemFont,\n    \"Segoe UI\",\n    Roboto,\n    sans-serif\n  ) !important;\n  transition: background-color 200ms ease, border-color 200ms ease;\n}\n\n/* --------------------------------------------------------------------------\n   Left Section (Desktop Burger + Mobile Controls + Search)\n   -------------------------------------------------------------------------- */\n.app-topbar__left {\n  display: flex !important;\n  align-items: center !important;\n  gap: 12px !important;\n  flex: 1 1 auto !important;\n  min-width: 0 !important;\n}\n\n.app-topbar__desktop-burger {\n  display: none !important;\n}\n\n@media (min-width: 1025px) {\n  body.sidebar-collapsed .app-topbar__desktop-burger,\n  .app-topbar__desktop-burger.is-visible {\n    display: inline-flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    width: 40px !important;\n    height: 40px !important;\n    min-width: 40px !important;\n    min-height: 40px !important;\n    padding: 0 !important;\n    margin: 0 !important;\n    border-radius: 10px !important;\n    border: 1px solid var(--tb-search-border) !important;\n    background-color: var(--tb-search-bg) !important;\n    color: var(--tb-text-muted) !important;\n    cursor: pointer !important;\n    outline: none !important;\n    transition: background-color 150ms ease, border-color 150ms ease,\n      color 150ms ease !important;\n    flex-shrink: 0 !important;\n  }\n\n  body.sidebar-collapsed .app-topbar__desktop-burger:hover,\n  .app-topbar__desktop-burger.is-visible:hover {\n    background-color: var(--tb-hover-bg) !important;\n    border-color: var(--tb-search-focus-border) !important;\n    color: var(--tb-text) !important;\n  }\n\n  .app-topbar__desktop-burger svg {\n    width: 20px !important;\n    height: 20px !important;\n    stroke: currentColor !important;\n    stroke-width: 2 !important;\n    display: block !important;\n  }\n}\n\n/* --------------------------------------------------------------------------\n   Mobile Controls (hamburger + mobile search button)\n   Hidden on desktop and tablet, visible on mobile phones (< 768px)\n   -------------------------------------------------------------------------- */\n.app-topbar__mobile-controls {\n  display: none !important;\n  align-items: center !important;\n  gap: 8px !important;\n}\n\n.app-topbar__mobile-btn {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  width: 44px !important;\n  height: 44px !important;\n  padding: 0 !important;\n  margin: 0 !important;\n  border-radius: 10px !important;\n  border: 1px solid var(--border-subtle, var(--tb-border)) !important;\n  background-color: var(--surface-secondary, var(--tb-search-bg)) !important;\n  color: var(--text-primary, var(--tb-text)) !important;\n  cursor: pointer !important;\n  outline: none !important;\n  transition: background-color 150ms ease, border-color 150ms ease;\n}\n\n.app-topbar__mobile-btn:hover {\n  background-color: var(--surface-tertiary, var(--tb-hover-bg)) !important;\n  border-color: var(--border-default, var(--tb-credits-border)) !important;\n}\n\n.app-topbar__mobile-btn svg {\n  width: 20px !important;\n  height: 20px !important;\n  stroke: currentColor !important;\n}\n\n/* --------------------------------------------------------------------------\n   Search Bar (Figma Node I429:22166;534:24814)\n   -------------------------------------------------------------------------- */\n.app-topbar__search {\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px !important;\n  width: 100% !important;\n  max-width: 320px !important;\n  min-width: 80px !important;\n  height: 40px !important;\n  padding: 0 12px !important;\n  margin: 0 !important;\n  border-radius: 10px !important;\n  border: 1px solid var(--tb-search-border) !important;\n  background-color: var(--tb-search-bg) !important;\n  box-sizing: border-box !important;\n  cursor: text !important;\n  transition: border-color 150ms ease, box-shadow 150ms ease,\n    background-color 150ms ease;\n}\n\n.app-topbar__search:focus-within {\n  border-color: var(--tb-search-focus-border) !important;\n  box-shadow: none !important;\n}\n\n.app-topbar__search-icon {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  width: 16px !important;\n  height: 16px !important;\n  flex-shrink: 0 !important;\n  color: var(--tb-text-tertiary) !important;\n}\n\n.app-topbar__search-icon svg {\n  width: 16px !important;\n  height: 16px !important;\n  display: block !important;\n  stroke: currentColor !important;\n}\n\n.app-topbar__search-input {\n  flex: 1 1 0% !important;\n  min-width: 0 !important;\n  width: 100% !important;\n  height: 100% !important;\n  padding: 0 !important;\n  margin: 0 !important;\n  border: none !important;\n  outline: none !important;\n  background: transparent !important;\n  color: var(--tb-text) !important;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif) !important;\n  font-size: 14px !important;\n  font-weight: 400 !important;\n  line-height: normal !important;\n  letter-spacing: 0 !important;\n}\n\n.app-topbar__search .app-topbar__search-clear {\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  flex: 0 0 28px !important;\n  width: 28px !important;\n  height: 28px !important;\n  padding: 4px !important;\n  border: 0 !important;\n  border-radius: var(--radius-sm, 4px) !important;\n  background: transparent !important;\n  color: var(--tb-text-tertiary) !important;\n  cursor: pointer !important;\n}\n\n.app-topbar__search .app-topbar__search-clear:hover {\n  background: var(--tb-hover-bg) !important;\n}\n\n.app-topbar__search .app-topbar__search-clear:focus-visible {\n  outline: 2px solid var(--tb-search-focus-border) !important;\n}\n\n.app-topbar__search .app-topbar__search-clear svg {\n  width: 16px !important;\n  height: 16px !important;\n  color: currentColor !important;\n}\n\n.app-topbar__search-input::placeholder {\n  color: var(--tb-text-tertiary) !important;\n  opacity: 1 !important;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif) !important;\n  font-size: 14px !important;\n  font-weight: 400 !important;\n}\n\n/* --------------------------------------------------------------------------\n   Top Actions (Figma Node I429:22166;534:21917)\n   -------------------------------------------------------------------------- */\n.app-topbar__actions {\n  display: flex !important;\n  align-items: center !important;\n  gap: 16px !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  flex-shrink: 0 !important;\n}\n\n/* Shared action-name tooltip for the right-side header controls. */\n.app-topbar__actions [data-tooltip]::after {\n  content: attr(data-tooltip);\n  position: absolute;\n  z-index: 1100;\n  top: calc(100% + 8px);\n  left: 50%;\n  padding: 6px 9px;\n  border: 1px solid var(--tb-menu-border);\n  border-radius: 6px;\n  background: var(--tb-menu-bg);\n  box-shadow: 0 4px 12px rgba(14, 26, 32, 0.14);\n  color: var(--tb-text);\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 16px;\n  white-space: nowrap;\n  pointer-events: none;\n  opacity: 0;\n  transform: translate(-50%, -4px);\n  transition: opacity 120ms ease, transform 120ms ease;\n}\n\n.app-topbar__actions [data-tooltip]:hover::after,\n.app-topbar__actions [data-tooltip]:focus-visible::after {\n  opacity: 1;\n  transform: translate(-50%, 0);\n}\n\n.app-topbar__profile-control.is-open::after {\n  display: none;\n}\n\n/* Credits Badge (Figma Node I429:22166;158:5021) */\n.app-topbar__credits {\n  display: inline-flex !important;\n  align-items: center !important;\n  gap: 6px !important;\n  height: 32px !important;\n  padding: 0 12px 0 10px !important;\n  margin: 0 !important;\n  border-radius: 999px !important;\n  border: 1px solid var(--tb-credits-border) !important;\n  background-color: transparent !important;\n  color: var(--tb-text) !important;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif) !important;\n  font-size: 13px !important;\n  font-weight: 500 !important;\n  line-height: normal !important;\n  white-space: nowrap !important;\n  cursor: pointer !important;\n  text-decoration: none !important;\n  box-sizing: border-box !important;\n  transition: background-color 150ms ease, border-color 150ms ease;\n}\n\n.app-topbar__credits:hover {\n  background-color: var(--tb-hover-bg) !important;\n}\n\n.app-topbar__credits-icon {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  width: 16px !important;\n  height: 16px !important;\n  flex-shrink: 0 !important;\n  color: var(--tb-icon) !important;\n}\n\n.app-topbar__credits-icon svg {\n  width: 16px !important;\n  height: 16px !important;\n  display: block !important;\n  stroke: currentColor !important;\n}\n\n/* Circle Action Buttons: Help & Notifications (Figma Nodes 158:5025, 158:5028) */\n.app-topbar__icon-btn {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  width: 36px !important;\n  height: 36px !important;\n  padding: 0 !important;\n  margin: 0 !important;\n  border-radius: 18px !important;\n  border: none !important;\n  outline: none !important;\n  background-color: transparent !important;\n  color: var(--tb-icon) !important;\n  cursor: pointer !important;\n  position: relative !important;\n  flex-shrink: 0 !important;\n  transition: background-color 150ms ease, color 150ms ease;\n}\n\n.app-topbar__icon-btn:hover {\n  background-color: var(--tb-hover-bg) !important;\n}\n\n.app-topbar__refresh-btn:focus-visible {\n  outline: 2px solid var(--focus-ring) !important;\n  outline-offset: 2px !important;\n}\n\n.app-topbar__icon-btn svg {\n  width: 20px !important;\n  height: 20px !important;\n  display: block !important;\n  stroke: currentColor !important;\n}\n\n/* Notification unread badge dot */\n.app-topbar__notif-badge {\n  position: absolute !important;\n  top: 7px !important;\n  right: 7px !important;\n  width: 7px !important;\n  height: 7px !important;\n  border-radius: 50% !important;\n  background-color: var(--tb-danger) !important;\n  border: 1.5px solid var(--tb-bg) !important;\n}\n\n/* Profile Control (Figma Node I429:22166;422:17533) */\n.app-topbar__profile-control {\n  display: flex !important;\n  align-items: center !important;\n  gap: 4px !important;\n  padding: 4px !important;\n  margin: 0 !important;\n  border-radius: 8px !important;\n  border: none !important;\n  outline: none !important;\n  background-color: transparent !important;\n  cursor: pointer !important;\n  position: relative !important;\n  flex-shrink: 0 !important;\n  transition: background-color 150ms ease;\n}\n\n.app-topbar__profile-control:hover,\n.app-topbar__profile-control.is-open {\n  background-color: var(--tb-hover-bg) !important;\n}\n\n/* Avatar (Figma Node I429:22166;158:5031) */\n.app-topbar__avatar {\n  position: relative !important;\n  width: 32px !important;\n  height: 32px !important;\n  border-radius: 16px !important;\n  border: 1.5px solid var(--tb-avatar-border) !important;\n  background-color: var(--tb-interactive) !important;\n  color: var(--tb-on-interactive) !important;\n  box-sizing: border-box !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif) !important;\n  font-size: 11px !important;\n  font-weight: 500 !important;\n  line-height: 1 !important;\n  user-select: none !important;\n  flex-shrink: 0 !important;\n}\n\n.app-topbar__avatar img {\n  width: 100% !important;\n  height: 100% !important;\n  border-radius: 16px !important;\n  object-fit: cover !important;\n  display: block !important;\n  pointer-events: none !important;\n}\n\n/* Online status dot & ring */\n.app-topbar__status-dot {\n  position: absolute !important;\n  right: -1px !important;\n  bottom: -1px !important;\n  width: 8px !important;\n  height: 8px !important;\n  border-radius: 50% !important;\n  background-color: var(--tb-status-dot) !important;\n  border: 1.5px solid var(--tb-status-ring) !important;\n  box-sizing: content-box !important;\n}\n\n/* Chevron Down (Figma Node I429:22166;422:17763) */\n.app-topbar__chevron {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  width: 16px !important;\n  height: 16px !important;\n  color: var(--tb-icon) !important;\n  transition: transform 160ms cubic-bezier(0.4, 0, 0.2, 1) !important;\n}\n\n.app-topbar__chevron svg {\n  width: 16px !important;\n  height: 16px !important;\n  display: block !important;\n  stroke: currentColor !important;\n}\n\n.app-topbar__profile-control.is-open .app-topbar__chevron {\n  transform: rotate(180deg) !important;\n}\n\n/* --------------------------------------------------------------------------\n   Profile Menu Popover\n   -------------------------------------------------------------------------- */\n.app-topbar__menu {\n  position: absolute !important;\n  top: calc(100% - 4px) !important;\n  right: 24px !important;\n  z-index: 1000 !important;\n  width: 240px !important;\n  padding: 4px !important;\n  border-radius: 10px !important;\n  border: 1px solid var(--tb-menu-border) !important;\n  background-color: var(--tb-menu-bg) !important;\n  box-shadow: 0 6px 16px -4px rgba(14, 26, 32, 0.1),\n    0 1px 2px rgba(14, 26, 32, 0.04) !important;\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 2px !important;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif) !important;\n  animation: appTopbarMenuIn 150ms cubic-bezier(0.16, 1, 0.3, 1) !important;\n}\n\n@keyframes appTopbarMenuIn {\n  from {\n    opacity: 0;\n    transform: translateY(-6px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.app-topbar__menu-credits {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n  padding: 10px 12px !important;\n  border-radius: 8px !important;\n  background-color: var(--tb-search-bg) !important;\n  border: 1px solid var(--tb-border) !important;\n  color: var(--tb-text) !important;\n  font-size: 13px !important;\n}\n\n.app-topbar__menu-credits > div {\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px !important;\n}\n\n.app-topbar__menu-credits strong {\n  font-weight: 600 !important;\n}\n\n.app-topbar__menu-btn {\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px !important;\n  width: 100% !important;\n  height: 36px !important;\n  padding: 0 12px !important;\n  margin: 0 !important;\n  border-radius: 4px !important;\n  border: none !important;\n  outline: none !important;\n  background: transparent !important;\n  color: var(--tb-text) !important;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif) !important;\n  font-size: 14px !important;\n  font-weight: 400 !important;\n  text-align: left !important;\n  cursor: pointer !important;\n  transition: background-color 120ms ease;\n}\n\n.app-topbar__menu-btn:hover {\n  background-color: var(--tb-menu-item-hover) !important;\n}\n\n.app-topbar__menu-btn svg {\n  width: 20px !important;\n  height: 20px !important;\n  stroke: currentColor !important;\n  color: var(--tb-text-muted) !important;\n  flex-shrink: 0 !important;\n}\n\n.app-topbar__menu-theme {\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: flex-start !important;\n  gap: 8px !important;\n  padding: 8px 12px !important;\n}\n\n.app-topbar__menu-theme > span {\n  font-size: 13px !important;\n  color: var(--tb-text-muted) !important;\n}\n\n.app-topbar__theme-toggle {\n  display: flex !important;\n  width: 168px !important;\n  height: 36px !important;\n  padding: 4px !important;\n  gap: 4px !important;\n  border-radius: 10px !important;\n  background-color: transparent !important;\n  border: none !important;\n}\n\n.app-topbar__theme-toggle button {\n  display: inline-flex !important;\n  align-items: center !important;\n  gap: 4px !important;\n  height: 28px !important;\n  width: 78px !important;\n  padding: 0 8px !important;\n  border-radius: 6px !important;\n  border: none !important;\n  background: transparent !important;\n  color: var(--tb-text-muted) !important;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif) !important;\n  font-size: 13px !important;\n  font-weight: 500 !important;\n  cursor: pointer !important;\n  transition: background-color 120ms ease, color 120ms ease;\n}\n\n.app-topbar__theme-toggle button.active {\n  background-color: var(--tb-bg) !important;\n  color: var(--tb-text) !important;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;\n}\n\n.app-topbar__theme-toggle button svg {\n  width: 14px !important;\n  height: 14px !important;\n  stroke: currentColor !important;\n}\n\n.app-topbar__theme-toggle button:focus-visible {\n  outline: 2px solid var(--focus-ring);\n  outline-offset: 3px;\n}\n\n.app-topbar__menu-divider {\n  width: 100% !important;\n  height: 1px !important;\n  background-color: var(--tb-border) !important;\n  margin: 4px 0 !important;\n}\n\n/* --------------------------------------------------------------------------\n   RESPONSIVE BREAKPOINTS\n   -------------------------------------------------------------------------- */\n\n/* Tablet (768px to 1024px) — Matches Figma Node 539:64178:\n   Full search and credits visible, mobile toggle hidden */\n@media (min-width: 768px) and (max-width: 1024px) {\n  #root .app-topbar,\n  .app-topbar {\n    padding: 0 24px !important;\n  }\n  body:has(.dashboard-product-identity) .app-topbar__mobile-controls,\n  .business-dashboard:has(.dashboard-product-identity)\n    .app-topbar__mobile-controls,\n  .dashboard-main:has(.dashboard-product-identity)\n    .app-topbar__mobile-controls {\n    display: none !important;\n  }\n  .app-topbar__search {\n    display: flex !important;\n    max-width: 320px !important;\n  }\n  .app-topbar__credits {\n    display: inline-flex !important;\n  }\n  .app-topbar__icon-btn {\n    display: flex !important;\n  }\n}\n\n/* Mobile Phones (max-width: 767px) — Matches Figma Node 551:41126:\n   Mobile controls shown, search input & credits hidden, bell + profile visible */\n@media (max-width: 767px) {\n  #root .app-topbar,\n  .app-topbar {\n    padding: 0 16px !important;\n  }\n  .app-topbar__mobile-controls {\n    display: flex !important;\n  }\n  .app-topbar__search {\n    display: none !important;\n  }\n  .app-topbar__search.is-mobile-open {\n    display: flex !important;\n    position: absolute !important;\n    left: 16px !important;\n    right: 16px !important;\n    top: 12px !important;\n    width: calc(100% - 32px) !important;\n    max-width: none !important;\n    z-index: 10 !important;\n    background-color: var(--tb-bg) !important;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;\n  }\n  .app-topbar__credits {\n    display: none !important;\n  }\n  .app-topbar__help-btn {\n    display: none !important;\n  }\n  .app-topbar__actions {\n    gap: 8px !important;\n  }\n  .app-topbar__menu {\n    right: 16px !important;\n    width: calc(100% - 32px) !important;\n    max-width: 280px !important;\n  }\n}\n\n.app-topbar__search {\n  position: relative;\n}\n\n.app-topbar__search-results {\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 0;\n  width: min(420px, calc(100vw - 32px));\n  max-height: 60vh;\n  overflow-y: auto;\n  padding: 8px;\n  border: 1px solid var(--tb-border);\n  border-radius: 10px;\n  background: var(--tb-menu-bg);\n  color: var(--tb-text);\n  box-shadow: var(--tb-menu-shadow);\n  z-index: 20;\n}\n\n.app-topbar__search-results p {\n  padding: 8px;\n  margin: 0;\n  font-size: 13px;\n}\n\n.app-topbar__search-results [role=\"option\"] {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  width: 100%;\n  padding: 10px;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: var(--tb-text);\n  text-align: left;\n  font: inherit;\n  cursor: pointer;\n}\n\n.app-topbar__search-results [role=\"option\"]:hover,\n.app-topbar__search-results [role=\"option\"][aria-selected=\"true\"] {\n  background: var(--tb-menu-item-hover);\n}\n\n.app-topbar__search-results button:focus-visible {\n  outline: 2px solid var(--tb-search-focus-border);\n}\n\n.app-topbar__search-results span,\n.app-topbar__search-results small {\n  color: var(--tb-text-muted);\n  font-size: 12px;\n  overflow-wrap: anywhere;\n}\n\n.app-topbar__search-results strong {\n  font-size: 14px;\n  overflow-wrap: anywhere;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
